import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {filter} from 'rxjs/operators';

export enum E_EVENT_TYPES {
    RELATIONS = 'relations',
    CDR = 'cdr'
}

interface IEventData {
    action: TEventActions;

    [key: string]: any;
}

type TEventActions = 'add' | 'edit' | 'remove';

/**
 * Сервис для обработки событий в карточке реестра.
 */
@Injectable()
export class FactorRowEventService {

    /** Получить наблюдателя для потока событий компонента */
    public get eventFlow$(): Observable<any> {
        return this._eventFlow$.asObservable();
    }

    /** Фильтр для событий связей */
    public static filterRelations =
        filter((data: { type: E_EVENT_TYPES, data: IEventData }) => {
            return data?.type === E_EVENT_TYPES.RELATIONS;
        });

    /** Поток событий в компоненте */
    private readonly _eventFlow$: Subject<any> = new Subject<any>();

    /** Разрушение класса (данный метод необходимо вызвать только в компоненте, в котором наблюдаем изменения) */
    public destructor() {
        this._eventFlow$.complete();
    }

    /** Инициировать событие компонента */
    public initEvent(type: E_EVENT_TYPES, data: IEventData) {
        const eventData = {
            type,
            data
        };
        this._eventFlow$.next(eventData);
    }
}
